import MDBox from "components/MDBox";
import axios from "axios";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";
import FormLabel from "@mui/material/FormLabel";
import { Checkbox, Col, Row } from "antd";
import CloseIcon from "@mui/icons-material/Close";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Completion from "./Completion";
import "../user_service_maintenace_mgmt/Somecss.css";

import {
  isValidUsername,
  isValidEmail,
  isValidPassword,
  isValidPhone,
  allowOnlyAlphanumeric,
} from "../../utils/Constant";

const services = [
  {
    name: "Charger Management",
    id: 1,
  },
  {
    name: "Driver Management",
    id: 9,
  },
  {
    name: "Supervisor Management",
    id: 15,
  },
  {
    name: "Vehicle Management",
    id: 13,
  },
  {
    name: "Location Management",
    id: 3,
  },
  // {
  //   name: "RFID Card",
  //   id: 18,
  // },
  {
    name: "Push Notifications",
    id: 5,
  },
  // {
  //   name: "Customer Service",
  //   id: 6,
  // },
  {
    name: "Analytics & Reports",
    id: 7,
  },
  {
    name: "Fault Management",
    id: 8,
  },
  {
    name: "Logs Management",
    id: 11,
  },
  {
    name: "Reservation",
    id: 12,
  },
  {
    name: "Bulk Upload Logs",
    id: 14,
  },
  {
    name: "Audit Logs",
    id: 17,
  },
    {
    name: "Vendor Performance",
    id: 16,
  },
];

function PopAddBasic1(props) {
  const [isDialogOpen, setIsDialogOpen] = useState(props.isDialog);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [isDisabled, setIsDisabled] = useState(false);
  const [isBackdrop, setIsBackdrop] = useState(false);
  const { onClose } = props;

  const [errors, setErrors] = useState({});

  const initialValues = {
    username: "",
    email: "",
    password: "",
    phone: "",
    company: "",
    department: "",
    serviceID: [],
  };

  const { enqueueSnackbar } = useSnackbar();
  const [values, setValues] = useState(initialValues);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;

    setErrors((prev) => {
      const next = { ...prev };

      switch (name) {
        case "username":
          if (!allowOnlyAlphanumeric(value)) {
            next.username = "Username should contain only letters and numbers";
          } else delete next.username;
          break;

        case "email":
          if (!isValidEmail(value)) {
            next.email = "Email must be valid";
          } else delete next.email;
          break;

        case "password":
          if (!isValidPassword(value)) {
            next.password =
              "Password must be at least 8 characters with 1 number and 1 special character";
          } else delete next.password;
          break;

        case "phone":
          if (!isValidPhone(value)) {
            next.phone =
              "Enter a valid mobile number (05XXXXXXXX or +9715XXXXXXXX)";
          } else delete next.phone;
          break;

        default:
          break;
      }

      return next;
    });
  };

  const [showPassword, setShowPassword] = useState(false);
  const reset = (event) => {
    event.preventDefault();
    setValues(initialValues);
    setErrors({});
  };

  const handleClose = () => {
    onClose(false);
  };

  const pop = () => {
    // force validation for required fields
    const fieldsToValidate = ["username", "email", "password", "phone"];

    fieldsToValidate.forEach((field) => {
      handleBlur({
        target: {
          name: field,
          value: values[field],
        },
      });
    });

    // wait for state update (React batches updates)
    setTimeout(() => {
      if (Object.keys(errors).length > 0) {
        enqueueSnackbar("Please fix validation errors", {
          variant: "error",
          autoHideDuration: 2000,
        });
        return;
      }

      if (!values.company || !values.department) {
        enqueueSnackbar("Company and Department are required", {
          variant: "error",
          autoHideDuration: 2000,
        });
        return;
      }

      setIsBackdrop(false);
      createUser();
    }, 0);
  };

  useEffect(() => {
    if (props.value) {
      setValues({
        ...initialValues,
        ...props.value,
      });
      setErrors({});
    }
  }, [props.value]);

  const createUser = () => {
    const payload = {
      email: values.email,
      username: values.username,
      password: values.password,
      "phone": {
        "prefix": "+97",
        "number": values.phone,
      }, company: values.company,
      serviceID: values.serviceID,
      department: values.department,
      role: "Manager",
    };

    onClose(false);
    axios({
      method: "post",
      url:
        process.env.REACT_APP_BASEURL +
        "user-service-and-maintenance/create-manager",
      data: payload,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.success === true) {
          setIsDisabled(!isDisabled);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.response?.data?.message, { variant: "error" });
      });
  };
  const onChange = (checkedValues) => {
    setValues((prevValues) => ({
      ...prevValues,
      serviceID: checkedValues,
    }));
  };
  useEffect(() => {
    setIsDialogOpen(props.isDialog);
  }, [props.isDialog]);
  return (
    <>
      <Completion isDialog={isDisabled} onClose={setIsDisabled} />
      <MDBackdrop isBackdrop={isBackdrop} />
      <Dialog open={isDialogOpen} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
              : {
                theme,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
          }
        >
          Add Manager Information
          <IconButton
            aria-label="delete"
            onClick={handleClose}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          style={
            darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
          }
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox pt={0}></MDBox>

            <MDBox p={1} component="form" role="form">
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Username"
                  value={values.username}
                  name="username"
                  fullWidth
                  onChange={handleChange}
                  error={!!errors.username}
                  helperText={errors.username}
                  onBlur={handleBlur}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      color: "error.main",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "error.main",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  value={values.password}
                  name="password"
                  onBlur={handleBlur}
                  fullWidth={true}
                  onChange={handleChange}
                  error={!!errors?.password}
                  helperText={errors?.password}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      color: "error.main",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "error.main",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="email"
                  label="Email"
                  value={values.email}
                  name="email"
                  onBlur={handleBlur}
                  fullWidth={true}
                  onChange={handleChange}
                  error={!!errors?.email}
                  helperText={errors?.email}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      color: "error.main",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "error.main",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="tel"
                  label="Phone Number"
                  value={values.phone}
                  name="phone"
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!errors?.phone}
                  helperText={errors?.phone}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      color: "error.main",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "error.main",
                    },
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel id="location-type-label">Company</InputLabel>
                  <Select
                    sx={{
                      height: 50,
                    }}
                    labelId="company-label"
                    id="company-select"
                    value={values.company}
                    name="company"
                    onChange={handleChange}
                    input={<OutlinedInput label="Company" />}
                  >
                    <MenuItem value="DTC">DTC</MenuItem>
                    <MenuItem value="Presight">Presight</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel id="location-type-label">Department</InputLabel>
                  <Select
                    sx={{
                      height: 50,
                    }}
                    labelId="department-label"
                    id="department-select"
                    value={values.department}
                    name="department"
                    onChange={handleChange}
                    input={<OutlinedInput label="Department" />}
                  >
                    <MenuItem value="IT & Support">IT & Support</MenuItem>
                    <MenuItem value="Human Resources">Human Resources</MenuItem>
                    <MenuItem value="Finance & Accounting">
                      Finance & Accounting
                    </MenuItem>
                    <MenuItem value="Operations">Operations</MenuItem>
                    <MenuItem value="Sales & Marketing">
                      Sales & Marketing
                    </MenuItem>
                    <MenuItem value="Product Management">
                      Product Management
                    </MenuItem>
                    <MenuItem value="Engineering & Development">
                      Engineering & Development
                    </MenuItem>
                    <MenuItem value="Quality Assurance">
                      Quality Assurance
                    </MenuItem>
                    <MenuItem value="Legal & Compliance">
                      Legal & Compliance
                    </MenuItem>
                    <MenuItem value="Procurement & Vendor Management">
                      Procurement & Vendor Management
                    </MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox p={1}>
                <FormLabel>Services</FormLabel>
              </MDBox>
              <MDBox p={1}>
                <Checkbox.Group
                  style={{
                    width: "100%",
                  }}
                  onChange={onChange}
                  value={values.serviceID}
                >
                  <Row gutter={16}>
                    {services.map((service, index) => (
                      <Col key={index} xs={24} sm={12} md={8}>
                        <Checkbox value={service.id}>{service.name}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                justifyContent: "space-evenly",
                color: "#ffffff",
              }
              : { theme, justifyContent: "space-evenly" }
          }
        >
          <MDButton
            type="button"
            variant="gradient"
            color={sidenavColor}
            onClick={reset}
          >
            Reset
          </MDButton>

          <MDButton variant="gradient" color={sidenavColor} onClick={pop}>
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PopAddBasic1;
